// src/lib/logSignupRequest.js

import { supabase } from "services/supabaseClient";

export async function logSignupRequest({
  email,
  domain,
  source,
  policyResult,
}) {
  try {
    await supabase.from("user_signup_requests").insert({
      email,
      domain,
      source,
      policy_result: policyResult,
      user_agent: navigator.userAgent,
    });
  } catch (err) {
    console.error("logSignupRequest failed", err);
  }
}

export default logSignupRequest;